import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Select, MenuItem, FormControl } from "@mui/material";
// import Chart from "react-apexcharts"; // Removing chart import
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'; // Changed icon to AssignmentOutlined for enquiries

const TotalEnquires = ({ data }) => {
  const [isChartLoaded, setChartLoaded] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("all");
  const [enquiryCount, setEnquiryCount] = useState(0);
  // const [chartData, setChartData] = useState([]); // Removing chartData state

  useEffect(() => {
    // No need to setChartLoaded if no chart
  }, []);

  useEffect(() => {
    if (data) {
      switch (selectedPeriod) {
        case "today":
          setEnquiryCount(data.today || 0);
          // setChartData([data.today || 0]); // Removing chart data update
          break;
        case "week":
          setEnquiryCount(data.last7Days || 0);
          // const weeklyData = Array(7).fill(Math.round((data.last7Days || 0) / 7)); // Removing chart data calculation
          // setChartData(weeklyData);
          break;
        case "month":
          setEnquiryCount(data.last30Days || 0);
          // const monthlyData = Array(30).fill(Math.round((data.last30Days || 0) / 30)); // Removing chart data calculation
          // setChartData(monthlyData);
          break;
        case "year":
          setEnquiryCount(data.lastYear || 0);
          // const yearlyData = Array(12).fill(Math.round((data.lastYear || 0) / 12)); // Removing chart data calculation
          // setChartData(yearlyData);
          break;
        default:
          setEnquiryCount(data.total || 0);
          // const allTimeData = Array(12).fill(Math.round((data.total || 0) / 12)); // Removing chart data calculation
          // setChartData(allTimeData);
      }
    }
  }, [selectedPeriod, data]);

  const handlePeriodChange = (event) => {
    setSelectedPeriod(event.target.value);
  };

  // Removing getXAxisCategories function

  // Removing series and options for the chart

  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: "7px",
          mb: "25px",
          padding: { xs: "18px", sm: "20px", lg: "25px" },
          background: "linear-gradient(135deg, #00796b 0%, #009688 100%)", // Using a different gradient for differentiation
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
        className="rmui-card"
      >
        {/* Large semi-circle on the left */}
        <Box
          sx={{
            position: 'absolute',
            top: '-50px',
            left: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)', // Semi-transparent white
            zIndex: 0,
          }}
        />
        {/* Smaller circle segment on the right */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '-50px',
            right: '-50px',
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)', // Semi-transparent white
            zIndex: 0,
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            position: "relative", // Ensure content is above circles
            zIndex: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
            {/* Icon - Using AssignmentOutlinedIcon for Enquiries */}
            <AssignmentOutlinedIcon 
              sx={{ 
                fontSize: 50, 
                opacity: 0.8,
                filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.1))", 
                flexShrink: 0,
                color: 'white', 
              }} 
            />
            <Box>
              <Typography 
                component="span" 
                sx={{ 
                  color: "white",
                  fontSize: "1rem", 
                  fontWeight: 500,
                  display: "block",
                  mb: 0.5
                }}
              >
                Total Enquiries
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  fontSize: 24,
                  fontWeight: 700,
                  color: "white",
                }}
              >
                {enquiryCount}
              </Typography>
            </Box>
          </Box>

          <FormControl sx={{ minWidth: 120, flexShrink: 0 , borderColor: "white"}}>
            <Select
              value={selectedPeriod}
              onChange={handlePeriodChange}
              size="small"
              sx={{
                color: "white",
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '.MuiSvgIcon-root': {
                  color: 'white',
                },
              }}
            >
              <MenuItem value="all">All Time</MenuItem>
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">Last 7 Days</MenuItem>
              <MenuItem value="month">Last 30 Days</MenuItem>
              <MenuItem value="year">Last Year</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Card>
    </>
  );
};

export default TotalEnquires;
